import React from "react";
import NeutralStaffFilled from "shared/Experimental/Icons/NeutralStaffFilled";
import NeutralStaffLine from "shared/Experimental/Icons/NeutralStaffLine";
import {useTranslation} from "@unibuddy/intl";
import IconTab from "../IconTab/IconTab";

export default function StaffHeaderTab(props) {
    const {t} = useTranslation("common");

    return (
        <IconTab
            {...props}
            id="staff"
            name={t("staff", "Staff")}
            onClick={props.onClick}
            to={props.to}
            icon={(isActive) => (isActive ? <NeutralStaffFilled /> : <NeutralStaffLine />)}
        />
    );
}
